import { CSSProperties, FC, PropsWithChildren } from "react";
import styled from "styled-components";
import { hexToRGB } from "@shared/utils/misc";

interface TagProps {
  style?: CSSProperties;
  color: string;
  bgColor?: string;
  onClick?: () => void;
  className?: string;
}

const Tag: FC<PropsWithChildren<TagProps>> = ({
  style,
  color,
  bgColor,
  onClick,
  className,
  children,
}) => {
  return (
    <StyledTag
      $color={color}
      $bgColor={bgColor}
      style={style}
      onClick={onClick}
      className={className}
    >
      {children}
    </StyledTag>
  );
};

export default Tag;

const StyledTag = styled.div<{ $color?: string; $bgColor?: string }>`
  color: ${(p) => p.$color};
  background: ${(p) => p.$bgColor || hexToRGB(p.$color, 0.12)};
  border: 1px solid transparent;
  font-size: 11px;
  font-weight: ${(p) => p.theme.typography.fontWeights.MEDIUM};
  width: min-content;
  padding: 2px 6px;
  border-radius: 4px;
  ${(p) =>
    p.onClick &&
    `
  cursor: pointer;
  `}
`;
